import classNames from 'classnames';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import { ProjectName } from 'CONFIG_TYPES';

import { LogoIcon } from '../Pages/Components/LogoIcon/LogoIcon';
import styles from './AccessDisabled.styles.m.css';

export const AccessDisabled: FC = () => {
  const { t } = useTranslation();
  const isShowLogo = PROJECT_NAME === ProjectName.Gemteam;

  return (
    <div className={styles.container}>
      <LogoIcon className={classNames(styles.logo, { [styles.logoShow]: isShowLogo })} />
      <h1 className={styles.title}>{t('call_invitation_window_guests_disabled_header')}</h1>
      <p className={styles.subTitle}>{t('call_invitation_window_guests_disabled_tips')}</p>
    </div>
  );
};
